<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/user']"><img src="assets/images/admin/backarrow.png" /> Back to User Management</a>
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap mt-4 pt-2 mb-5">
    <div class="adminInnerHead">
        <div class="row">
            <div class="col-12 col-md-6" *ngIf="userDetail.userList">
                <div class="userDetail">
                    <h2 >{{userDetail.userList.first_name}} {{userDetail.userList.last_name}}<small>Created on {{userDetail.userList.created_dttm |  date:'d MMM, y'}}</small></h2>
                    <!-- <h3>{{userDetail.userList.}}</h3> -->
                    <h3>{{userDetail.userList.organisation_name}}</h3>
                    <div class="userDetailSocial">
                        <a href="mailto:rajeevsrivastava@gmail.com"><b><img src="assets/images/admin/mail.png" /></b>{{userDetail.userList.email}}</a>
                        <a href="tel:+9197465 73721"><b><img src="assets/images/admin/phone.svg" /></b>{{userDetail.userList.phone}}</a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <ul class="customTab">
                    <li><a href="javascript:void(0);" [routerLink]="['/view_courses']" [queryParams]="{user_id:userID}">VIEW COURSES</a> </li>
                    <li><a href="javascript:void(0);" [routerLink]="['/assign_courses']"[queryParams]="{user_id:userID}" class="active">ASSIGN COURSES</a> </li>
                    <li><a href="javascript:void(0);" [routerLink]="['/user_edit']" [queryParams]="{id:userID,type:'edit'}">EDIT</a> </li>
                    <li *ngIf="userDetail?.userList?.is_active==1" class="deactiveTab"><a href="javascript:void(0);" [routerLink]="['/user_deactive']" [queryParams]="{user_id:userID}">DEACTIVATE</a> </li>
                    <li *ngIf="userDetail?.userList?.is_active==0" class="activeTab"><a href="javascript:void(0);" [routerLink]="['/user_deactive']" [queryParams]="{user_id:userID}">ACTIVATE</a> </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="formHeading pr-0">
        <div class="row m-0">
            <div class="col-12 col-md-6">
        <h2>Assign Courses</h2>
        <p>Select 1 or more courses from the list to assign to this user. </p>
    </div>
    <div class="col-12 col-md-6">
        <div class="filterWrap">
            <div class="searchWrap mr-0">
                <input type="text" placeholder="Search by Course Name" (keyup)="search($event)">
            </div>
        </div>

        </div>
        </div>
    </div>
    <br>


    <div class="tableWrap">
        <table matSort (matSortChange)="sortData($event)">
            <thead>
                <tr>
                    <th class="assignUser">
                    <div class="customCheck">
                        <!-- <mat-checkbox></mat-checkbox> -->
                        <mat-checkbox id="all" [ngModel]="isCheckeds"  [checked]="false" (change)="onChange($event)">ALL</mat-checkbox>
                    </div>
                    </th>
                    <th><div mat-sort-header="course_name"><b></b> Course Name</div></th>
                    <th>Description</th>
                    <th>Modules</th>
                    <th>Sub Modules</th>
                    <th>Assessments</th>
                </tr>
            </thead>
            <tbody>
                <tr class="selectTr" *ngFor="let values of courseData; let i = index">
                    <td *ngIf="values.is_user_used_course == 0">
                        <div class="customCheck">
                            <mat-checkbox  [ngModel]="isCheckeds" [checked]="true"  (change)="onChangeDemo($event,values.course_id,i)"></mat-checkbox>
                        </div>
                    </td>

                    <td *ngIf="values.is_user_used_course == 1">
                        <div class="customCheck">
                            <mat-checkbox color="primary"  *ngIf="values.is_user_used_course==1" [disabled]="true" [checked]="true" ></mat-checkbox>
                            <!-- <mat-checkbox  *ngIf="values.is_user_used_course==0" (change)="onChangeDemo($event,values.course_id,i)"></mat-checkbox> -->
                        </div>
                    </td>

                    <td>
                        <div class="courseTdWrap">
                            <a href="javascript:void(0);">{{values.course_name}} </a><br>
                            <b>Created on {{ values.created_dttm |  date:'d MMM, y'}}</b><br>
                            <b>End on {{ values.end_date |  date:'d MMM, y'}}</b>
                        </div>
                    </td>
                    <td>
                       {{values.course_desc}}
                    </td>
                    <td>{{values.course_module_count}}</td>
                    <td>{{values.course_Submodule_count}}</td>
                    <td>{{values.totalassesment}}</td>

                </tr>

             </tbody>
        </table>

        <div class="text-center fixBottom">
            <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="open(content)" [ngClass]="(selectCourseId.length < 5 ) ? 'btn btn-primary btn-sm ' :
            'btn btn-primary btn-sm' ">Assign Courses</a>
        </div>
        <!-- <div class="text-center">
            <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="open(content)" [ngClass]="(selectUserId.length < 1 ) ? 'btn btn-primary btn-sm disable ' :
            'btn btn-primary btn-sm' ">Assign Users To Courses</a>
        </div> -->
    </div>
</div>
<ng-template #content let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <h6>Assign Courses</h6>
            <p class="size18">Are you sure you want to assign it is the courses selected?</p>
            <input type="hidden" (click)="modal.dismiss('Cross click')" id="CloseIds">
            <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="modal.dismiss('Cross click')">No,
                cancel</a>
            <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="publish()">Yes, Assign</a>
        </div>
    </div>
</ng-template>
